import React from 'react'
import BookReader from '../components/Book/BookReader'

function BookReaderView() {
  return (
    <BookReader />
  )
}

export default BookReaderView